module.exports = __webpack_public_path__ + "img/birgit-amann.d8af55ca.png";